<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="650"
    :visible="visible"
    @cancel="hideModal"
    :footer="null"
  >
    <img :src="photoUrl" style="width: 100%; height: auto" />
  </a-modal>
</template>

<script>
import { getStoreHttpUrl } from '@/utils/util'

export default {
  name: 'ViewPhoto',
  props: {
    title: {
      type: String,
      default: '查看照片',
    },
  },
  data() {
    return {
      visible: false,
      photoUrl: '',
    }
  },
  methods: {
    showModal(data) {
      this.visible = true
      this.photoUrl = getStoreHttpUrl(data.studentPic)
    },
    hideModal() {
      this.visible = false
      this.photoUrl = ''
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-body {
    padding: 10px 24px;
  }
}
</style>
